import { render } from "./AppToggle.vue?vue&type=template&id=4d8e97e2&scoped=true&ts=true"
import script from "./AppToggle.vue?vue&type=script&lang=ts"
export * from "./AppToggle.vue?vue&type=script&lang=ts"

import "./AppToggle.vue?vue&type=style&index=0&id=4d8e97e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8e97e2"]])

export default __exports__